import locale from './locale';
import * as yup from 'yup';

yup.setLocale(locale);

export default yup;
